/* eslint-disable no-console */
import type { UserDataOptions } from 'apps/shared/data-access/types/metadata/metadata.types';
import { WebStorageKeys } from 'apps/core/types/web-storage.types';
import { getWebStorage } from 'utils/web-storage';

type UserKey = `${string}-${WebStorageKeys}`;

const createUserKey = (value: WebStorageKeys): UserKey => {
  const userData = getWebStorage<UserDataOptions>(WebStorageKeys.USER_DATA);
  if (userData === undefined) {
    console.error('User data is undefined');
    return value as unknown as UserKey;
  }
  return `${userData.userId}-${value}`;
};

export const getUserWebStorage = <T>(key: WebStorageKeys): T | undefined => {
  const userKey = createUserKey(key);
  const data: string | null = sessionStorage.getItem(userKey) ?? localStorage.getItem(userKey);
  try {
    return data ? (JSON.parse(data) as T) : undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const setUserWebStorage = <T>(
  key: WebStorageKeys,
  value: T | string | number | Record<string, unknown>,
): void => {
  const userKey = createUserKey(key);

  const data: string = typeof value === 'string' ? value : JSON.stringify(value);
  sessionStorage.setItem(userKey, data);
  localStorage.setItem(userKey, data);
};

export const removeUserWebStorage = (key: WebStorageKeys): void => {
  const userKey = createUserKey(key);

  sessionStorage.removeItem(userKey);
  localStorage.removeItem(userKey);
};
